import { unflatten } from 'flat';
import React from 'react';
import PropTypes from 'prop-types';

const TitleInListApprovals = ({ record }) => {
  const recortUnflatten = unflatten(record);
  const { title, mediaUrl } = recortUnflatten.params;

  let updatedTitle = title;
  if (!title || title.length === 0) {
    updatedTitle = mediaUrl;
  }

  let updatedMediaUrl = mediaUrl;
  if (mediaUrl && mediaUrl.length > 0 && !mediaUrl.startsWith('http')) {
    updatedMediaUrl = `https://${mediaUrl}`;
  }

  return (<a target="_blank" rel="noreferrer" href={updatedMediaUrl}>{updatedTitle}</a>);
};
TitleInListApprovals.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default TitleInListApprovals;

